import { Box, Button, Container } from '@mui/material';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import ErrorDialog from '@/components/shared/errorDialog';
import { MobiTitle } from '@/components/shared/MobiTitle';
import { ApiNamePaths } from '@/constants/rest-api-name-path';
import { apiDelete } from '@/modules/hooks/use-delete';
import * as paths from '@/routes/paths';
import { settingState } from '@/state/settingState';

type ErrorMsg = {
  message: string;
};

const LogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const [, setSetting] = useRecoilState(settingState);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorOPen, setErrorOpen] = useState(false);
  const { t } = useTranslation();
  const logout = async () => {
    const idToken = (await fetchAuthSession()).tokens?.idToken;
    apiDelete(ApiNamePaths.vehicleDriverApi.apiName, `${ApiNamePaths.vehicleDriverApi.apiPath}`, {
      body: {
        driverId: idToken,
      },
    })
      .then(() => {
        signOut()
          .then(async () => {
            setSetting(undefined);
            navigate(paths.login);
          })
          // ログアウトが成功したら指定したパスに遷移
          .catch(() => {});
      })
      .catch((error: ErrorMsg) => {
        setErrorMessage(error.message);
        setErrorOpen(true);
      });
  };

  return (
    <Container maxWidth="xs">
      <MobiTitle>{t('header.logout')}</MobiTitle>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
        }}
      >
        <Button
          type="submit"
          fullWidth
          variant="outlined"
          color="inherit"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            void logout();
          }}
        >
          {t('header.logout')}
        </Button>
      </Box>
      {errorOPen ? (
        <ErrorDialog open={errorOPen} errorMessage={errorMessage} onClose={(flag) => setErrorOpen(flag)} />
      ) : null}
    </Container>
  );
};

export default LogoutPage;
